import * as T from '../constants/types';
import { Auth } from 'aws-amplify';
import { NEW_PASSWORD_REQUIRED } from '../constants/variables';
import { throwError } from './throwNotification';

export const onSignIn = () => async (dispatch, getState) => {
    const { loginForm: { password, login } } = getState();
    try {
        const cognitoUser = await Auth.signIn(login, password);
        if (cognitoUser.challengeName === NEW_PASSWORD_REQUIRED) {
            return dispatch({ type: T.NEW_USER_PASSWORD_RESET });
        }
        dispatch({ type: T.SIGN_IN + T.SUCCESS });
        window.location.href = '/';
    } catch (error) {
        dispatch(throwError(error, T.SIGN_IN + T.ERROR));
    }
};
